import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import withExtendedStyles from "@sendmagic/prismic-nextjs/src/hoc/withExtendedStyles";

import defaultStyles from "./main.module.scss";

const Cards = ({
  card_background_color,
  image,
  card_heading,
  card_heading_color,
  card_description,
  card_description_color,
  first_cta,
  second_cta,
  first_cta_link,
  second_cta_link,
  image_alignment = "bottom",
  card_subheading,
  card_subheading_color,
  card_subdescription,
  card_subdescription_color,
  separator_toggler,
  sliceStyles: styles = defaultStyles,
}) => {
  const firstBtnDesign = first_cta?.[0]?.spans?.[0]?.data.label;
  const secondBtnDesign = second_cta?.[0]?.spans?.[0]?.data.label;

  const btnClass = {
    "button-filled-beige": styles.buttonFilledBeige,
    "button-bordered-beige": styles.buttonBorderedBeige,
    "button-empty-beige": styles.buttonEmptyBeige,
    "button-filled": styles.buttonFilled,
    "button-bordered": styles.buttonBordered,
    "button-empty": styles.buttonEmpty,
  };
  const renderDescription = () =>
    checkContentPresence(card_description) && (
      <div className={styles.verticalCardsBlockContent} style={{ color: card_description_color }}>
        {textResolver(card_description, { convertLabelToModular: true })}
      </div>
    );

  const renderSubHeadingAndSubDescription = () => (
    <div className={styles.verticalCardsBlockHeader}>
      {checkContentPresence(card_subheading) && (
        <div
          className={styles.verticalCardsBlockSubheading}
          style={{ color: card_subheading_color }}
        >
          {textResolver(card_subheading, { convertLabelToModular: true })}
        </div>
      )}
      {checkContentPresence(card_subdescription) && (
        <div
          className={styles.verticalCardsBlockSubdescription}
          style={{ color: card_subdescription_color }}
        >
          {textResolver(card_subdescription, { convertLabelToModular: true })}
        </div>
      )}
    </div>
  );

  const renderImage = () => (
    <div className={styles.verticalCardsBlockImageRow}>
      <PrismicImgix
        className={styles.verticalCardsBlockImage}
        src={image?.url}
        alt={image?.alt}
        desktop="296px"
        mobile="245px"
        tablet="248px"
        largeDisplay="560px"
      />
    </div>
  );
  return (
    <div className={styles.verticalSliceCardBlock} style={{ background: card_background_color }}>
      {checkContentPresence(card_heading) && (
        <div className={styles.verticalCardsBlockTitle} style={{ color: card_heading_color }}>
          {textResolver(card_heading, { convertLabelToModular: true })}
        </div>
      )}

      {image_alignment === "bottom" ? (
        <>
          {renderSubHeadingAndSubDescription()}
          {!separator_toggler && <hr className={styles.verticalCardsBlockSeparator} />}
          {renderDescription()}
          {renderImage()}
        </>
      ) : (
        <>
          {renderImage()}
          {renderSubHeadingAndSubDescription()}
          {!separator_toggler && <hr className={styles.verticalCardsBlockSeparator} />}
          {renderDescription()}
        </>
      )}

      {checkContentPresence(first_cta) && (
        <div className={`${styles.verticaCardsBlockButtonRow}`}>
          <PrismicLinkTag
            urlText={first_cta}
            url={first_cta_link?.url}
            target={first_cta_link?.target}
            convertLabelToModular
            labelClass={btnClass[firstBtnDesign]}
          />
        </div>
      )}
      {checkContentPresence(second_cta) && (
        <div className={`${styles.verticaCardsBlockButtonRow}`}>
          <PrismicLinkTag
            urlText={second_cta}
            url={second_cta_link?.url}
            target={second_cta_link?.target}
            className={styles.verticalCardsBlockLink}
            convertLabelToModular
            labelClass={btnClass[secondBtnDesign]}
          />
        </div>
      )}
    </div>
  );
};

const VerticalCards = ({ doc, sliceStyles: styles }) => {
  const { background_color, title, title_color, description, description_color, internal_link_id } =
    doc?.primary || {};

  return (
    <div className={styles.verticalCardsSlice} style={{ background: background_color }}>
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className={styles.verticalCardsContainer}>
        {checkContentPresence(title) && (
          <div className={styles.verticalCardsSliceTitle} style={{ color: title_color }}>
            {textResolver(title, { convertLabelToModular: true })}
          </div>
        )}
        {checkContentPresence(description) && (
          <div
            className={styles.verticalCardsSliceDescription}
            style={{ color: description_color }}
          >
            {textResolver(description, { convertLabelToModular: true })}
          </div>
        )}
        <div className={styles.verticalCardsContentSection}>
          {doc.items.map((props, index) => (
            <Cards {...props} key={`card-${index}`} sliceStyles={styles} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default withExtendedStyles(VerticalCards, ({ appName }) => ({
  styleImport: () => {
    switch (appName) {
      case "swagmagic":
        return import(
          /* webpackChunkName: "PriVerticalCardsSwagmagicStyles" */ "./swagmagic.module.scss"
        );
      default:
        return import(/* webpackChunkName: "PriVerticalCardsdefaultStyles" */ "./main.module.scss");
    }
  },
}));
